import Tooltip from "rc-tooltip";
import React from "react";

export default function CheckRegistryPointsBtn(props) {
    return (
        <div className="map-bid-legend">
            <Tooltip overlay="Проверить точку в реестре точек выгрузок" placement="right">
                <div
                    className="map-bid-legend__button map-bid-legend__button--region"
                    onClick={props.checkRegistryPoints}
                />
            </Tooltip>
        </div>
    );
}
